<template>
    <div class="project-detail" style="padding: 0 10px">
        <div class="project-detail-header">
            <p>{{ data.title }}</p>
            <span> 发布时间： </span>
            <span> 阅读次数： </span>
        </div>
        <div class="project-detail-info">
            <div class="project-detail-info-mark" />
            <!-- <div class="project-detail-info-item">
                <span class="data-label">当前状态</span>
                <span style="color: #5bffd9">{{ data.statusText }}</span>
            </div> -->
            <div class="project-detail-info-item">
                <span class="data-label">项目编号</span>
                <span>{{ data.code }}</span>
            </div>
            <div class="project-detail-info-item">
                <span class="data-label">招标人</span>
                <span>{{ data.creator }}</span>
            </div>
            <div class="project-detail-info-item">
                <span class="data-label">项目类型</span>
                <span>{{ data.projectType }}</span>
            </div>
            <div class="project-detail-info-item">
                <span class="data-label">采购方式</span>
                <span>{{ data.type }}</span>
            </div>
        </div>
        <zl-card-title title="开标流程">
            <div style="padding: 10px 0">
                <van-steps :active="activeStep">
                    <van-step v-for="(item, index) in stepList" :key="index">{{
                        item.label
                    }}</van-step>
                </van-steps>
            </div>
            <div class="jiemi">
                <div class="jiemi-title">解密剩余时间</div>
                <div class="jiemi-time">
                    <span class="hour">00</span>
                    <span> : </span>
                    <span class="minute">00</span>
                    <span> : </span>
                    <span class="secoud">00</span>
                </div>
            </div>
        </zl-card-title>
        <!-- <van-tabs v-model="active">
            <van-tab title="进度播报" />
            <van-tab title="开标直播" />
        </van-tabs> -->
    </div>
</template>

<script>
    import ZlCardTitle from '@/components/ZlCardTitle'
    import { Tabs, Tab, Skeleton, Step, Steps } from 'vant'
    const {
        stepList,
        mixin,
    } = require(`@/config/${process.env.VUE_APP_PROJECT}/bidOpeningDetail`)

    export default {
        name: 'BidOpeningDetail',
        components: {
            [Tabs.name]: Tabs,
            [Tab.name]: Tab,
            [Skeleton.name]: Skeleton,
            [Step.name]: Step,
            [Steps.name]: Steps,
            ZlCardTitle,
        },
        mixins: [mixin],
        data() {
            return {
                data: [],
                stepList,
                currNodeCode: 'a',
                currentIndex: 0,
                active: 0,
                activeStep: 0,
            }
        },
        created() {
            this.getData()
        },
    }
</script>

<style lang="less">
@blue: #136fd1;
@import '../../assets/style/projectDetail.scss';
.project-detail {
  height: 100%;
  .van-steps {
    padding-top: 15px;
  }
  .van-steps {
    padding-top: 15px;
  }
  .van-step:nth-child(even) {
    .van-step__title {
      transform: translateX(-50%) translateY(200%);
    }
  }
  .van-step__title {
    font-size: 13px !important;
  }
  .van-icon-checked {
    font-size: 20px !important;
  }
  .van-step__title--active {
    background: #02b38a;
    color: #fff;
    padding: 2px 7px;
    border-radius: 10px;
  }
  .van-step__title {
    transform: translateX(-50%) translateY(-50%);
  }

  .van-step--horizontal:first-child .van-step__title {
    transform: translateY(-50%) !important;
  }
  .van-step--horizontal:last-child:not(:nth-child(odd)) .van-step__title {
    transform: translateY(200%) !important;
  }
  .van-step--horizontal:last-child:not(:nth-child(even)) .van-step__title {
    transform: translateY(-50%) !important;
  }
  .jiemi {
    background: url('../../assets/images/project/sekuiai4.png') no-repeat;
    background-size: 100%;
    background-position: 0px -10px;
    height: 110px;
    &-title {
      text-align: center;
      padding-top: 15px;
      color: #fff;
      font-size: 14px;
    }
    &-time {
      text-align: center;
      padding-top: 5px;
      color: #fff;
      font-size: 30px;
      .hour,
      .day,
      .minute,
      .secoud {
        position: relative;
      }
      .day::after {
        content: '天';
      }
      .hour::after {
        content: '时';
      }
      .minute::after {
        content: '分';
      }
      .secoud::after {
        content: '秒';
        position: absolute;
      }
      .hour::after,
      .day::after,
      .minute::after,
      .secoud::after {
        position: absolute;
        left: 12px;
        bottom: -12px;
        font-size: 12px;
        color: rgb(185, 195, 208);
      }
    }
  }
}
</style>
